<template>
  <v-app>
    <v-main class="pago-confirmado-bg">
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="6" lg="4">
            <v-card class="pa-8 text-center rounded-xl elevation-12">
              <v-icon size="80" color="success" class="mb-4"
                >mdi-check-circle</v-icon
              >

              <h1 class="text-h5 font-weight-bold mb-3">
                ¡Turno confirmado! 🎾
              </h1>

              <p class="text-body-1 grey--text text--darken-1 mb-6">
                Tu pago fue procesado correctamente. El turno quedó reservado a
                tu nombre. Recibirás un email de confirmación en breve.
              </p>

              <v-btn color="primary" large rounded @click="volver">
                <v-icon left>mdi-arrow-left</v-icon>
                Volver al inicio
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "PagoConfirmado",
  methods: {
    volver() {
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.pago-confirmado-bg {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  min-height: 100vh;
}
</style>
